import * as Api from '../api';

export interface UploadedImage {
  /** Short-lived signed URL — use immediately, refresh via SignImages later. */
  url: string;
  /** B2 object key — persist on the <img> as `data-b2-key`. */
  key: string;
}

/** The key is what the editor stores; the URL is only the first-load handle (the bucket is private). */
export async function uploadImageToS3(file: File, context?: string): Promise<UploadedImage> {
  const response = await Api.UploadImage({ file, context });
  return { url: response.data.data.url, key: response.data.data.key };
}
